import { render, staticRenderFns } from "./service-detail.vue?vue&type=template&id=0c27716c&scoped=true&"
import script from "./service-detail.vue?vue&type=script&lang=js&"
export * from "./service-detail.vue?vue&type=script&lang=js&"
import style0 from "./service-detail.vue?vue&type=style&index=0&id=0c27716c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27716c",
  null
  
)

export default component.exports